import { useQuery } from "@tanstack/react-query";
import {
  fetchMetaAdsInsightsDaily,
  isMetaAdsApiConfigured,
} from "./useMetaAdsApi";

/**
 * Daily Meta insights time series for charts (one point per day for the selected date preset).
 */
export function useMetaAdsInsightsDaily({
  entityType,
  entityId,
  datePreset = "last_30d",
  enabled = true,
}) {
  return useQuery({
    queryKey: ["meta-ads-insights-daily", entityType, entityId, datePreset],
    queryFn: () => fetchMetaAdsInsightsDaily(entityType, entityId, datePreset),
    enabled: Boolean(enabled && entityId && isMetaAdsApiConfigured()),
    staleTime: 60_000,
  });
}
